<template>
  <chart :chart-data="datacollection">
  </chart>
</template>
<script>
    import Chart from "../views/chart.js";
    export default {
        components: {
            Chart
        },
        data() {
            return {
                datacollection: null
            };
        },
        mounted() {
            this.fillData();
        },
        methods: {
            fillData() {
                this.datacollection = {
                    datasets: [{
                        data: [10, 20, 30, 50],
                        backgroundColor: ['#ff6384', '#36a2eb', '#ffce56'],
                        borderWidth: 0,
                    }],
                    // These labels appear in the legend and in the tooltips when hovering different arcs
                    labels: [
                        'Red',
                        'Yellow',
                        'Blue',
                        'Green'
                    ]
                }
            },
        }
    };
</script>

<style>
</style>